module.exports = __webpack_public_path__ + "img/icon3.2f7a116b.png";